export default __webpack_public_path__ + "static/avatar-dont-3-9fb2599fa30987309ee4396255b4a768.png";